import type { DicStayAreaListParams } from "../types";

export const dicStayAreaPageSizeOptions = [20, 50, 100] as const;

export const dicStayAreaDefaultListParams: DicStayAreaListParams = {
  page: 1,
  pageSize: 20,
  sortField: "updated_at",
  sortDirection: "desc",
};

export const dicStayAreaStatusOptions = [
  { label: "全部状态", value: "" },
  { label: "启用", value: "false" },
  { label: "停用", value: "true" },
] as const;

export const dicStayAreaLevelOptions = [
  { label: "省", value: "province" },
  { label: "市", value: "city" },
  { label: "区县", value: "district" },
  { label: "镇/乡/街道", value: "town" },
  { label: "村", value: "village" },
  { label: "片区", value: "area" },
] as const;

/** 层级展示复用表单中文名称，并兼容历史手工区域和未识别结果。 */
export const dicStayAreaLevelLabels: Record<string, string> = {
  ...Object.fromEntries(dicStayAreaLevelOptions.map(({ value, label }) => [value, label])),
  manual: "手工区域",
  unknown: "待补充",
};
